var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.new-item",modifiers:{"new-item":true}}],staticClass:"btn btn-success mt-5 mb-2",attrs:{"type":"button"},on:{"click":_vm.newOrder}},[_vm._v(" + افزودن به سفارش ")])}
var staticRenderFns = []

export { render, staticRenderFns }